module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-7-70bedb63.jpg";